import {debounce} from 'lodash';

export default {
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      sort: '-id',
      fetchUrl: null,
      expand: null
    }
  },
  created() {
    this.fetchData = debounce(this.fetchData, 100);
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    sort () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.fetchDataInternal()
    },
    fetchDataInternal () {
      let config = {
        params: {
          "filter[status]": 1,
          page: this.currentPage,
          'per-page': this.pageSize,
          sort: this.sort
        }
      }
      this.handleFetchConfig(config)
      return this.$http.get(this.$urls[this.fetchUrl], config).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.tableData = res.data
        if (this.expand) {
          this.expandTable(this.$store.state.expand)
        }
      })
    },
    handleFetchConfig (config) {},
    handleSort ({column, prop, order}) {
      this.sort = order === 'ascending' ? prop : ('-' + prop)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    }
  }
}